import type { SortDirection } from './table'
import type { Dispatch, SetStateAction } from 'react'

import { useState } from 'react'

export interface SortState<T extends Record<string, unknown>> {
  field: keyof T
  direction: SortDirection
}

interface Props<T extends Record<string, unknown>> {
  field: keyof T
  direction: SortDirection
}

export function useTableSort<T extends Record<string, unknown>> ({ field, direction }: Props<T>): { sort: SortState<T>, setSort: Dispatch<SetStateAction<SortState<T>>> } {
  const [ sort, setSort ] = useState<{ field: keyof T, direction: SortDirection }>({ field, direction })

  return { sort, setSort }
}
